<template>
    <div class="main-content">
        <Page1 @escolhePersona="escolhePersona" :locked1="locked1"></Page1>
        <!-- <Page2 v-if="!locked1" :persona="persona" @preencheDadosIniciais="preencheDadosIniciais"></Page2> -->
        <Page3 v-if="!locked1" :persona="persona"></Page3>
        <Page4 v-if="!locked1" :persona="persona"></Page4>
        <Page4part2 v-if="!locked1" :persona="persona"></Page4part2>
        <Page5 v-if="!locked1" :persona="persona"></Page5>
        <Page6 v-if="!locked1" :persona="persona" ></Page6>
        <Page7 v-if="!locked1" :persona="persona" @refreshAos="refreshAos"></Page7>
        <Page8 v-if="!locked1" :persona="persona"></Page8>
        <Page10 v-if="!locked1" :persona="persona" @refreshAos="refreshAos"></Page10>
        <Page9 v-if="!locked1" :persona="persona" :basicForm="basicForm"></Page9>
        
    </div>
</template>

<script>
import Page1 from '@/views/Page1'
// import Page2 from '@/views/Page2'
import Page3 from '@/views/Page3'
import Page4 from '@/views/Page4'
import Page4part2 from '@/views/Page4part2'
import Page5 from '@/views/Page5'
import Page6 from '@/views/Page6'
import Page7 from '@/views/Page7'
import Page8 from '@/views/Page8'
import Page9 from '@/views/Page9'
import Page10 from '@/views/Page10'

export default {
    props: ['persona', 'locked1', 'locked2', 'basicForm'],
    methods: {
        escolhePersona(value) {
            this.$emit("escolhePersona", value);
        },
        preencheDadosIniciais(obj) {
            this.$emit("preencheDadosIniciais", obj);
        },
        pulaPreenchimentoInicial() {
            this.$emit("pulaPreenchimentoInicial");
        },
        refreshAos() {
            this.$emit("refreshAos");
        }
    },
    components: {
        Page1,
        // Page2,
        Page3,
        Page4,
        Page4part2,
        Page5,
        Page6,
        Page7,
        Page8,
        Page9,
        Page10
    }
}
</script>